import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 足球联赛
import footballLeagueRouter from '@router/football/league_commonRouter'
// CSL|中超
import footballLeague_CSLRouter from '@router/football/league_csl'

const {
  FootballLeagueScheduleIndex,
  FootballLeagueTeamRankIndex,
  FootballLeagueScheduleDetailIndex,
  FootballLeagueScheduleDetailPreMatch,
  FootballLeagueScheduleDetailLineup,
  FootballLeagueScheduleDetailAnalysis,
  FootballLeagueScheduleDetailStatistics,
  FootballLeagueTeamIndex,
  FootballLeagueTeamDetailIndex,
  FootballLeagueTeamDetailTeamData,
  FootballLeagueTeamDetailPlayerList,
  FootballLeagueTeamDetailMatchRecord,
  FootballLeagueTeamDetailMatchSchedule,
  FootballLeagueRecordDetailIndex,
  FootballLeagueRecordDetailDataOverview,
  FootballLeagueRecordDetailTeamData,
  FootballLeagueRecordDetailPlayerData,
  FootballLeagueRecordDetailLineupData,
  FootballLeaguePlayerIndex,
  FootballLeaguePlayerDetailIndex,
  FootballLeaguePlayerDetailSeasonData,
  FootballLeaguePlayerDetailCareerData,
  FootballLeaguePlayerDetailMatchRecord,
  FootballLeagueSportsHallIndex,
  FootballLeagueBroadcastListIndex,
  FootballLeagueDataPackagListIndex,
  FootballLeagueProgramListIndex,
} = footballLeagueRouter
const { PlatfromFootballLeagueFullCSL } = footballLeague_CSLRouter

const pathModuleBase = 'platfromFootballLeagueFull'
const diffCompetitionTypeArr = [
  {
    name: 'FBLCSL',
    pathModule: 'FBLCSL',
    component: PlatfromFootballLeagueFullCSL,
  }, // csl
]

const baseChildren = [
  // pathModule 默认占位是CSL
  {
    path: 'schedule', //football/league/赛程
    name: 'scheduleIndex', // 最终生成的name是 scheduleIndex_FBLCSL
    component: FootballLeagueScheduleIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'teamRank', //football/league/赛程
    name: 'teamRankIndex',
    component: FootballLeagueTeamRankIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'teamRank'],
      requireLogin: false,
      title: '球队排名',
    },
  },
  {
    path: 'scheduleDetail', //football/league/赛程详情
    redirect: { name: 'scheduleDetailPreMatch' },
    name: 'scheduleDetailIndex',
    component: FootballLeagueScheduleDetailIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'schedule'],
      requireLogin: false,
    },
    children: [
      {
        path: 'preMatch', //football/league/赛程详情-赛前
        name: 'scheduleDetailPreMatch',
        component: FootballLeagueScheduleDetailPreMatch,
        meta: {
          pathModule: ['football', 'FBLCSL', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'lineup', //football/league/赛程详情-阵容
        name: 'scheduleDetailLineup',
        component: FootballLeagueScheduleDetailLineup,
        meta: {
          pathModule: ['football', 'FBLCSL', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'analysis', //football/league/赛程详情-数据分析
        name: 'scheduleDetailAnalysis',
        component: FootballLeagueScheduleDetailAnalysis,
        meta: {
          pathModule: ['football', 'FBLCSL', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'statistics', //football/league/赛程详情-数据统计
        name: 'scheduleDetailStatistics',
        component: FootballLeagueScheduleDetailStatistics,
        meta: {
          pathModule: ['football', 'FBLCSL', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
    ],
  },
  {
    path: 'team', //football/league/球队
    name: 'teamIndex',
    component: FootballLeagueTeamIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'team'],
      requireLogin: false,
      title: '球队',
    },
  },
  {
    path: 'teamDetail', //football/league/球队详情
    redirect: { name: 'teamDetailPlayerList' },
    name: 'teamDetailIndex',
    component: FootballLeagueTeamDetailIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'team'],
      requireLogin: false,
    },
    children: [
      {
        path: 'playerList', //football/league/球队详情-名单
        name: 'teamDetailPlayerList',
        component: FootballLeagueTeamDetailPlayerList,
        meta: {
          pathModule: ['football', 'FBLCSL', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'teamData', //football/league/球队详情-数据
        name: 'teamDetailTeamData',
        component: FootballLeagueTeamDetailTeamData,
        meta: {
          pathModule: ['football', 'FBLCSL', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'matchRecord', //football/league/球队详情-比赛统计
        name: 'teamDetailMatchRecord',
        component: FootballLeagueTeamDetailMatchRecord,
        meta: {
          pathModule: ['football', 'FBLCSL', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'matchSchedule', //football/league/球队详情-赛程
        name: 'teamDetailMatchSchedule',
        component: FootballLeagueTeamDetailMatchSchedule,
        meta: {
          pathModule: ['football', 'FBLCSL', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
    ],
  },
  {
    path: 'record', //football/league/数据中心
    redirect: { name: 'recordDetailDataOverview' },
    name: 'recordDetailIndex',
    component: FootballLeagueRecordDetailIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'record'],
      requireLogin: false,
    },
    children: [
      {
        path: 'dataOverview', //football/league/数据中心-数据概览
        name: 'recordDetailDataOverview',
        component: FootballLeagueRecordDetailDataOverview,
        meta: {
          pathModule: ['football', 'FBLCSL', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'teamData', //football/league/数据中心-球队数据
        name: 'recordDetailTeamData',
        component: FootballLeagueRecordDetailTeamData,
        meta: {
          pathModule: ['football', 'FBLCSL', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'playerData', //football/league/数据中心-球员数据
        name: 'recordDetailPlayerData',
        component: FootballLeagueRecordDetailPlayerData,
        meta: {
          pathModule: ['football', 'FBLCSL', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'lineupData', //football/league/数据中心-阵容数据
        name: 'recordDetailLineupData',
        component: FootballLeagueRecordDetailLineupData,
        meta: {
          pathModule: ['football', 'FBLCSL', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
    ],
  },
  // {
  //   path: 'recordDataOverview', //football/league/数据中心-数据概览
  //   name: 'recordDataOverviewIndex',
  //   component: FootballLeagueRecordDataOverviewIndex,
  //   meta: {
  //     pathModule: ['football', 'FBLCSL', 'record'],
  //     requireLogin: false,
  //     title: '数据中心',
  //   },
  // },
  // {
  //   path: 'recordTeamData', //football/league/数据中心-球队数据
  //   name: 'recordTeamDataIndex',
  //   component: FootballLeagueRecordTeamDataIndex,
  //   meta: {
  //     pathModule: ['football', 'FBLCSL', 'record'],
  //     requireLogin: false,
  //     title: '数据中心',
  //   },
  // },
  // {
  //   path: 'recordPlayerData', //football/league/数据中心-球员数据
  //   name: 'recordPlayerDataIndex',
  //   component: FootballLeagueRecordPlayerDataIndex,
  //   meta: {
  //     pathModule: ['football', 'FBLCSL', 'record'],
  //     requireLogin: false,
  //     title: '数据中心',
  //   },
  // },
  {
    path: 'player', //football/league/球员
    name: 'playerIndex',
    component: FootballLeaguePlayerIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'player'],
      requireLogin: false,
      title: '球员',
    },
  },
  {
    path: 'playerDetail', //football/league/球员详情
    redirect: { name: 'playerDetailSeasonData' },
    name: 'playerDetailIndex',
    component: FootballLeaguePlayerDetailIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'player'],
      requireLogin: false,
    },
    children: [
      {
        path: 'seasonData', //football/league/球员详情-综合数据
        name: 'playerDetailSeasonData',
        component: FootballLeaguePlayerDetailSeasonData,
        meta: {
          pathModule: ['football', 'FBLCSL', 'player'],
          requireLogin: false,
          title: '球员详情',
        },
      },
      {
        path: 'careerData', //football/league/球员详情-生涯数据
        name: 'playerDetailCareerData',
        component: FootballLeaguePlayerDetailCareerData,
        meta: {
          pathModule: ['football', 'FBLCSL', 'player'],
          requireLogin: false,
          title: '球员详情',
        },
      },
      {
        path: 'matchRecord', //football/league/球员详情-比赛统计
        name: 'playerDetailMatchRecord',
        component: FootballLeaguePlayerDetailMatchRecord,
        meta: {
          pathModule: ['football', 'FBLCSL', 'player'],
          requireLogin: false,
          title: '球员详情',
        },
      },
    ],
  },
  {
    path: 'sportsHall', //football 联赛-场馆
    name: 'sportsHallIndex',
    component: FootballLeagueSportsHallIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'sportsHall'],
      requireLogin: false,
      title: '场馆',
    },
  },
  {
    path: 'broadcastList', //football 联赛-播出单
    name: 'broadcastListIndex',
    component: FootballLeagueBroadcastListIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //football 联赛-数据包装
    name: 'dataPackagListIndex',
    component: FootballLeagueDataPackagListIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'programListIndex',
    component: FootballLeagueProgramListIndex,
    meta: {
      pathModule: ['football', 'FBLCSL', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /FBLCSL
  name: `${pathModuleBase}_${routerItem.name}`, // platfromFootballLeagueFull_FBLCSL
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default { football_FBLCSL_RouterMode: routerModeArr[0] }
